__turbopack_context__.v({
  "brandName": "ZQ0GBa_brandName",
  "categoryName": "ZQ0GBa_categoryName",
  "deetDiv": "ZQ0GBa_deetDiv",
  "desc": "ZQ0GBa_desc",
  "imageWrapper": "ZQ0GBa_imageWrapper",
  "leftPad": "ZQ0GBa_leftPad",
  "loanAvailable": "ZQ0GBa_loanAvailable",
  "noRoundBottom": "ZQ0GBa_noRoundBottom",
  "productCard": "ZQ0GBa_productCard",
  "productImage": "ZQ0GBa_productImage",
  "tagsDiv": "ZQ0GBa_tagsDiv",
});
